export default __webpack_public_path__ + "static/data-composer-screenshot-b86d07c933a9af20fb5a2309240766f5.png";